import { render } from "./payoneer.vue?vue&type=template&id=6aac505f&scoped=true"
import script from "./payoneer.vue?vue&type=script&lang=js"
export * from "./payoneer.vue?vue&type=script&lang=js"

import "./payoneer.vue?vue&type=style&index=0&id=6aac505f&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aac505f"]])

export default __exports__